import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import ConditionCard from "./ConditionCard";
import ConditionNode from "./ConditionNode";

const SortableStepItem = ({ item, onEdit, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
  };

  const isCondition = item.conditions !== null;

  return (
    <div ref={setNodeRef} style={style} className="w-full flex justify-center">
      <div className="flex items-start gap-3">
        <div
          {...attributes}
          {...listeners}
          className="cursor-grab active:cursor-grabbing p-2 hover:bg-gray-100 rounded transition-colors mt-2 flex-shrink-0"
        >
          <GripVertical size={20} className="text-gray-400" />
        </div>
        <div className="flex-shrink-0">
          {isCondition ? (
            <ConditionCard
              condition={item}
              stepOrder={item.step_order}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ) : (
            <ConditionNode data={item} onEdit={onEdit} onDelete={onDelete} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SortableStepItem;
